<app-loader *ngIf="!isDataReady"></app-loader>
<div class="ui-g" *ngIf="isDataReady">
    <div class="ui-sm-12 ui-md-12 ui-lg-9 ui-xl-9" style="padding-left: 0">
        <form [formGroup]="userDetailsForm" (ngSubmit)="onSubmit()">
            <span class="ui-float-label" style="margin-bottom: 20px;">
                <input id="login-input" name="login" type="text" pInputText style="width: 100%;" formControlName="login">
                <label for="login-input">{{ 'login_name' | translate }}</label>
            </span>
            <span class="ui-float-label" style="margin-bottom: 20px;">
                <input id="name-input" name="name" type="text" pInputText style="width: 100%;" formControlName="name">
                <label for="name-input">{{ 'name' | translate }}</label>
            </span>
            <span class="ui-float-label" style="margin-bottom: 20px;">
                <input id="surname-input" name="surname" type="text" pInputText style="width: 100%;" formControlName="surname">
                <label for="surname-input">{{ 'surname' | translate }}</label>
            </span>
            <span class="ui-float-label" style="margin-bottom: 10px;">
                <input id="phone-input" name="phone" type="number" pInputText style="width: 100%;" formControlName="phone">
                <label for="phone-input">{{ 'phone_no' | translate }}</label>
            </span>

            <div *ngIf="isEditing == false">
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2" style="padding-left: 0">
                    <button (click)="startEditing()" pButton type="button" label="{{ 'edit' | translate }}" class="ui-button-info"  style="width: 100%;"></button>
                </div>
            </div>

            <div class="ui-g" *ngIf="isEditing == true">
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2" style="padding-left: 0">
                    <button pButton type="submit" [disabled]="!userDetailsForm.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
                </div>
                <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2">
                    <button (click)="cancelEditing()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
                </div>
            </div>
        </form>
    </div>
    <div class="ui-sm-12 ui-md-12 ui-lg-3 ui-xl-3">
      <div *ngIf="myImagePath" class="myImage">
        <img [src]="myImagePath | safeHtml" alt="my_image" />
      </div>
    </div>
</div>
